import React, { Component } from "react";
import {Modal, Row, Button} from "react-bootstrap";

const FormErrors = ({formErrors, errorId}) => (
  formErrors && (
    <div id={errorId} className='formErrors' role="alert" aria-live="assertive">
      {Object.keys(formErrors).map((fieldName, i) => {
        if(formErrors[fieldName].length > 0 ){
          return (
            <p className="form-validation-error" key={i}> {formErrors[fieldName]}</p>
          )
        } else {
          return '';
        }
      })}
    </div>
  )
);

export class ModalDialog extends Component {
  constructor(props){
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
      const { lastFocusedElement } = this.props;

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
      }

      if(this.props.handleClose){
      this.props.handleClose();
    }
  }

  render() {
    const { showModal, modalID, titleID, categoryID, contentID, title, contentBody, footerBtnBsStyle, footerBtnClass, footerBtnOnClick, footerBtnText,footerBtnCloseText, formErrors, errorId, bodyPaddingBottom } = this.props;
    const btnDisabled = contentBody?.props?.content?.props?.children?.props?.data?.length <= 0 || false;
    const btnClass = btnDisabled ? "KnoaSuccessButtonDisabled" : footerBtnClass;
    const describedByIds = [categoryID, contentID].filter(Boolean).join(" ")

    return (
      <Modal show={showModal} onHide={this.handleClose} aria-labelledby={modalID}>
        <Modal.Header closeButton>
          <Modal.Title className="dialog-title" id={modalID}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{paddingBottom: bodyPaddingBottom ? bodyPaddingBottom : "15px", paddingTop: "15px"}} aria-labelledby={titleID || undefined} aria-describedby={describedByIds || undefined}>
          {formErrors &&
            <Row className="dialog-row-error">
              <FormErrors formErrors={formErrors} errorId={errorId}/>
            </Row>
          }
          {contentBody}
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={btnDisabled} variant={footerBtnBsStyle} className={`${btnClass} ms-auto`} onClick={footerBtnOnClick}>{footerBtnText}</Button>
            {this.props.handleClose && <Button variant="secondary" onClick={this.handleClose}>{footerBtnCloseText}</Button>}
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalDialog;